// Carry Roll RecommendationRail — club recommendation for target (10.4).

import { useState } from 'react';
import { ExpressionInput } from 'calc-controls';
import { useStore } from '../../store';
import { recommendClub } from '@carry-roll/shared-logic';
import { distanceToM, mToYd } from '@carry-roll/shared-logic';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function RecommendationRail() {
  const bag = useStore((s) => s.bag);
  const env = useStore((s) => s.request.environment);
  const distanceUnit = useStore((s) => s.distanceUnit);
  const [target, setTarget] = useState(0);

  const targetM = target > 0 ? distanceToM(target, distanceUnit) : null;
  const rec = targetM != null ? recommendClub(targetM, bag, env) : null;
  const conv = (m: number) => (distanceUnit === 'yd' ? Math.round(mToYd(m)) : Math.round(m));

  return (
    <div className="panel" data-testid="recommendation-rail">
      <h3 className="subsection-title">
        Recommendation
      </h3>
      <div className="block mb-2">
        <span className="field-label">
          Target distance ({distanceUnit})
          <HelpTooltip label="Target distance">The yardage you need to cover. The closest-carrying club in your bag is recommended.</HelpTooltip>
        </span>
        <ExpressionInput
          inline
          value={target}
          onChange={setTarget}
          unit={distanceUnit}
          aria-label="Target distance"
          decimals={0}
          min={0}
        />
      </div>
      {rec && rec.club && (
        <p className="text-sm">
          {rec.club.clubName} carries {conv(rec.club.carryM)} {distanceUnit}, nearest to your {conv(targetM!)} {distanceUnit} target.
        </p>
      )}
      {rec && !rec.club && (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          {rec.message}
        </p>
      )}
      {!rec && (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Set a target distance to get a club recommendation.
        </p>
      )}
    </div>
  );
}
